import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import React from 'react';
import { List, Card } from 'antd';
import { JsonLd } from 'react-schemaorg';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { listDesign } from '../HeaderMenu/NewDesignButton/mockDataTemplatesSize';
import withi18next from '~/hocs/withi18next';
import { getSmallThumbnailURL } from '~/utils/canvasUtils/getSmallThumbnailURL';
import { editURLInBrowser } from '~/utils/mainHelpers/editURLInBrowser';
import ModalPreviewTemplate from '~/components/ModalPreviewTemplate';
import dataHelpers from '~/utils/dataHelpers';

@withi18next()
class GridLayout extends React.Component {
  state = {
    templatePreviewModalVisible: false,
    selectedCatName: '',
    selectedCatSlug: '',
    selectedTemplate: {
      title: '',
      width: 0,
      height: 0,
      thumbnail_url: '',
      workarea_unit: 'px',
      categories: [],
    },
    currentTemplateTags: [],
  };

  handleEditTemplate = (item) => {
    window.open(`/design/${item.id}`, '_blank');
  };

  handleOpenEditPage = (item) => {
    const { catSlug } = this.props;
    const data = listDesign.find((item) => item.cat_slug === catSlug);
    if (data) {
      window.open(
        `/design/new-blank?width=${data.width}&height=${data.height}&unit=${data.unit}`,
        '_blank',
      );
    } else window.open('/design/new-blank', '_blank');
  };

  handleOpenTemplatePreviewModal = (templatePreviewModalVisible) => {
    this.setState({ templatePreviewModalVisible });
  };

  setSelectedTemplate = (selectedTemplate) => {
    this.setState({ selectedTemplate });
  };

  render() {
    const {
      templatePreviewModalVisible,
      selectedTemplate,
      selectedCatName,
      selectedCatSlug,
      currentTemplateTags,
    } = this.state;

    const {
      templates,
      newYearTemplates,
      selectedCategoryID,
      texts,
      t,
      catSlug,
      catNameByLang,
      i18n,
      isTemplatePage,
      isSearchPage,
      searchKeyword,
    } = this.props;

    let currentLang = i18n.language;
    if (currentLang === 'ja') {
      currentLang = 'jp';
    }
    let fnTemplates = [
      {
        isNewItem: true,
      },
    ];
    fnTemplates = fnTemplates.concat(templates);
    fnTemplates = fnTemplates.map((item) => {
      if (item.category) {
        try {
          const catName = JSON.parse(item.category.name);
          const catSlug = item.category.cat_slug;
          return {
            ...item,
            category: {
              id: item.category.id,
              name: catName[`cat_name_${currentLang}`],
              cat_slug: catSlug,
            },
          };
        } catch (error) {
          return item;
        }
      }
      return item;
    });
    return (
      <>
        <List
          loading={this.props.isLoadingTemplates}
          grid={{
            gutter: 10,
            xs: 2,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 6,
            xxl: 8,
          }}
          dataSource={fnTemplates}
          renderItem={(item) => {
            let itemCatSlug = '';
            let itemCatName = '';
            if (item.category && item.category.name && item.category.cat_slug) {
              itemCatSlug = item.category.cat_slug;
              itemCatName = item.category.name;
            }
            const thumbnailUrl = getSmallThumbnailURL(item.thumbnail_url);
            if (item.isNewItem) {
              return (
                <List.Item>
                  <Card
                    onClick={async () => {
                      await this.handleOpenEditPage(item);
                    }}
                    hoverable
                    bodyStyle={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 250,
                      padding: 10,
                      flexDirection: 'column',
                      backgroundColor: 'rgb(237, 240, 242)',
                      border: '1px solid rgba(64, 87, 109, 0.07)',
                      borderRadius: '4px',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        boxShadow:
                          '0 0 0 1px rgba(68,92,116,.02), 0 2px 8px rgba(57,76,96,.15)',
                        borderRadius: '50%',
                        border: '2px solid transparent',
                        backgroundColor: '#fff',
                        marginBottom: 10,
                        width: 64,
                        height: 64,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPlus}
                        style={{
                          fontSize: 40,
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      />
                    </div>
                    <span style={{ width: '70%', textAlign: 'center' }}>
                      {t('ace-text-new-design-button', {
                        cat:
                          catNameByLang || itemCatName || t('ace-text-design'),
                      })}
                    </span>
                  </Card>
                </List.Item>
              );
            } else {
              const { title, tags } = item;
              // Build category name
              const itemCategoryName = catNameByLang || itemCatName;

              // Build title
              const titleText =
                title ||
                t('ace-template-default-title-text', {
                  categoryName: itemCategoryName,
                  templateID: item.id,
                });

              // Build tags
              const tagNames = dataHelpers.buildTagNames(tags);

              const imageAltText = t('ace-template-thumbnail-alt-text', {
                templateTitle: titleText,
                tagNames: tagNames || itemCategoryName,
                categoryName: itemCategoryName,
              });
              const imageTitleText = t('ace-template-thumbnail-title-text', {
                templateTitle: titleText,
                categoryName: itemCategoryName,
              });

              return (
                <List.Item>
                  <Card
                    onClick={async () => {
                      this.setSelectedTemplate({
                        id: item.id,
                        title: item.title,
                        height: item.height,
                        width: item.width,
                        thumbnail_url: item.thumbnail_url,
                        workarea_unit: item.workarea_unit,
                        num_pages: item.num_pages,
                        tags: item.tags,
                        category: item.category || { id: item.category_id },
                        categories: item.categories || [],
                      });
                      this.handleOpenTemplatePreviewModal(true);
                      this.setState({
                        selectedCatName: catNameByLang || itemCatName,
                        selectedCatSlug: catSlug || itemCatSlug,
                        currentTemplateTags: item.tags,
                      });
                      editURLInBrowser(
                        `/free-template/${catSlug || itemCatSlug}-template-${
                          item.id
                        }`,
                      );
                    }}
                    hoverable
                    bodyStyle={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 250,
                      width: '100%',
                      padding: 10,
                    }}
                    style={{
                      overflow: 'hidden',
                      backgroundColor: 'rgb(237, 240, 242)',
                      border: '1px solid rgba(64, 87, 109, 0.07)',
                      borderRadius: '4px',
                    }}
                  >
                    <figure className="image-figure">
                      <a
                        className="image-figure"
                        href={`/free-template/${
                          catSlug || itemCatSlug
                        }-template-${item.id}`}
                        onClick={(e) => e.preventDefault()}
                      >
                        <img
                          alt={imageAltText}
                          title={imageTitleText}
                          data-src={thumbnailUrl}
                          loading="lazy"
                          layout="intrinsic"
                          className="template-image lazyload"
                          width={item.width}
                          height={item.height}
                          style={
                            item.width > item.height
                              ? { width: '100%', height: 'auto' }
                              : { width: 'auto', height: '100%' }
                          }
                        />
                        <div className="image-mask"></div>
                        <figcaption className="image-figcaption">
                          {titleText}
                        </figcaption>
                        <noscript>
                          <img
                            src={thumbnailUrl}
                            loading="lazy"
                            alt={imageAltText}
                            title={imageTitleText}
                          />
                        </noscript>
                        <JsonLd
                          item={{
                            '@context': 'https://schema.org',
                            '@type': 'ImageObject',
                            name: titleText,
                            contentUrl: thumbnailUrl,
                            thumbnail: thumbnailUrl,
                          }}
                        />
                      </a>
                    </figure>
                  </Card>
                </List.Item>
              );
            }
          }}
        >
          <style jsx global>
            {`
              .image-mask {
                background: linear-gradient(
                  to bottom,
                  rgba(40, 54, 69, 0) 0%,
                  rgba(40, 54, 69, 0.1) 50%,
                  rgba(40, 54, 69, 0.7) 100%
                );
                display: block;
                overflow: hidden;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                bottom: 0px;
                box-sizing: border-box;
                margin: 0px;
                z-index: 2;
                opacity: 0;
              }

              .image-figcaption {
                display: flex;
                align-items: flex-end;
                overflow: hidden;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                bottom: 0px;
                box-sizing: border-box;
                margin: 0px;
                z-index: 3;
                opacity: 0;
                font-weight: bold;
                color: white;
                padding-bottom: 20px;
                padding-left: 10px;
                font-size: 13px;
              }

              .image-figure {
                display: contents;
                overflow: hidden;
                position: absolute;
                top: 0px;
                left: 0px;
                right: 0px;
                bottom: 0px;
                box-sizing: border-box;
                margin: 0px;
              }

              .image-figure:hover .image-figcaption {
                opacity: 1;
              }

              .image-figure:hover .image-mask {
                opacity: 1;
              }

              .template-image-wrapper {
                padding: 10px;
              }

              .template-image {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
                filter: drop-shadow(0 0 0.75rem rgba(53, 71, 90, 0.2));
              }

              .lazyload:not([src]) {
                visibility: hidden;
              }
            `}
          </style>
        </List>
        <ModalPreviewTemplate
          isTemplatePage={isTemplatePage}
          isSearchPage={isSearchPage}
          searchKeyword={searchKeyword}
          catSlug={catSlug || selectedCatSlug}
          catNameByLang={catNameByLang || selectedCatName}
          visible={templatePreviewModalVisible}
          handleOpenTemplatePreviewModal={this.handleOpenTemplatePreviewModal}
          selectedTemplate={selectedTemplate}
          currentTemplateTags={currentTemplateTags}
          templates={fnTemplates}
          setSelectedTemplate={this.setSelectedTemplate}
        />
      </>
    );
  }
}

export default GridLayout;
